<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import axios from "axios";
import { authHeader } from "../../../helpers/auth-header";

import ConfirmationModal from "@/components/modals/confirmation-modal";
import MessageModal from "@/components/modals/message-modal";

import InputGroup from "@/components/forms/input-group";
import SelectGroup from "@/components/forms/select-group";
import SaveButton from "@/components/buttons/save-button";

/**
 * Orders Component
 */
export default {
    components: {
        Layout,
        PageHeader,
        ConfirmationModal,
        MessageModal,
        InputGroup,
        SelectGroup,
        SaveButton
    },
    data() {
        const id = this.$route.params.id;
        const modeName = id === 'add' ? 'Add' : 'Edit';

        return {
            id: id,
            title: `Treatment Category ${modeName}`,
            modeName,
            items: [
                {
                    text: "Treatment Category"
                },
                {
                    text: modeName,
                    active: true,
                },
            ],

            data: {
                category_id: '',
                name: '',
                status: 1,
            },
            statusOptions: [
                { name: 'Active', value: 1 },
                { name: 'Inactive', value: 0 },
            ],

            errors: {},
        };
    },
    computed: {

    },
    async mounted() {
        if (this.modeName !== 'Add') {
            const result = await axios.get(`${process.env.VUE_APP_APIURL}/category/${this.id}`, {
                headers: authHeader(),
            });
            if (result && result.data['code'] === 'success') {
                const data = result.data['data']['category'];
                for (const [key, item] of Object.entries(data)) {
                    if (key in this.data) {
                        this.data[key] = item;
                    }
                }

                const data2 = result.data['data']['category']['description'];
                for (const [key, item] of Object.entries(data2)) {
                    if (key in this.data) {
                        this.data[key] = item;
                    }
                }
            }
        }
    },
    methods: {
        async save() {
            this.errors = {};

            let result;
            if (this.modeName === 'Add') {
                const requestData = this.data;
                result = await axios.post(`${process.env.VUE_APP_APIURL}/category`, requestData, {
                    headers: authHeader(),
                });
            } else {
                const filteredPairs = Object.entries(this.data).filter(([key]) => !['password', 'password_confirmation'].includes(key));
                const requestData = Object.fromEntries(filteredPairs);
                result = await axios.put(`${process.env.VUE_APP_APIURL}/category/${this.id}`, requestData, {
                    headers: authHeader(),
                });
            }

            if (result) {
                if (result.data['code'] === 'success') {
                    if (this.modeName === 'Add') {
                        this.$router.back();
                    } else {
                        this.$refs.messageModal.showModal('Your record has been updated successfully');
                    }
                } else if (result.data['code'] === 'invalid_field') {
                    this.errors = result.data['errors'];
                }
            }
        },
    }
};
</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <ConfirmationModal ref="confirmationModal" />
        <MessageModal ref="messageModal" />
        <div class="card p-3">
            <div class="row no-gutters">
                <div class="col-12 col-md-6 col-lg-4 pl-2">
                    <InputGroup type="text" id="name" displayName="Name*" v-model="data.name" :error="errors.name" />
                </div>
                <div class="col-12 col-md-6 col-lg-4 pl-2">
                    <SelectGroup id="status" displayName="Status*" v-model="data.status" :error="errors.status" :options="statusOptions" />
                </div>
            </div>
            <div class="row mt-2 pl-2">
                <div class="col-12">
                    <SaveButton @click="save" />
                </div>
            </div>
        </div>
    </Layout>
</template>